import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokhatushyamtour() {



    const cardData = {

keyword: "Pune to Khatu Shyam Tour Package",

headingDescription:
    "Rising Cab Service offers a safe, comfortable, and well-planned Pune to Khatu Shyam Tour Package for devotees and spiritual travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, Mini Bus, and Luxury Urbania options with experienced chauffeurs for long-distance pilgrimage journeys to Rajasthan. With doorstep pickup across Pune, customized travel itineraries, one-way and round-trip packages, 24/7 support, and transparent pricing, we ensure a peaceful and hassle-free Khatu Shyam Ji darshan experience for families and groups.",

topPlaces: [
    {
        title: "Khatu Shyam Ji Temple (Sikar, Rajasthan)",
        description:
            "Khatu Shyam Ji Temple is one of the most revered pilgrimage sites in India, dedicated to Barbarik (Khatu Shyam), believed to be an incarnation of Lord Krishna. Devotees visit this temple seeking blessings, wish fulfillment, and spiritual peace. The temple is famous for its vibrant devotion, long queues of pilgrims, and powerful spiritual atmosphere throughout the year."
    },
    {
        title: "Shyam Kund",
        description:
            "Shyam Kund is a sacred water tank located near the Khatu Shyam Temple, believed to be the place where Barbarik’s head was found. Devotees take holy dips or offer prayers here before visiting the main temple, considering it highly auspicious and spiritually purifying."
    },
    {
        title: "Gaurishankar Temple (Khatu)",
        description:
            "Gaurishankar Temple is an ancient Shiva temple located near Khatu Shyam Ji. It adds additional spiritual value to the pilgrimage and is often visited by devotees as part of a complete darshan experience in the region."
    },
    {
        title: "Ringas Junction (Gateway to Khatu)",
        description:
            "Ringas Junction is the nearest railway and transport hub for Khatu Shyam Ji Temple. It acts as a major arrival point for pilgrims traveling from across India, including those coming from long-distance tours like Pune."
    },
    {
        title: "Jeen Mata Temple (Nearby)",
        description:
            "Jeen Mata Temple is a famous Shakti Peeth located near Khatu Shyam Ji. It is dedicated to Goddess Durga and is visited by devotees as part of a combined spiritual circuit in Rajasthan."
    },
    {
        title: "Salasar Balaji Temple (Extension Tour)",
        description:
            "Salasar Balaji Temple is another major pilgrimage destination in Rajasthan dedicated to Lord Hanuman. Many devotees combine Khatu Shyam Ji and Salasar Balaji in a single tour package for a complete spiritual journey."
    },
    {
        title: "Sikar City Temples",
        description:
            "Sikar city has several ancient temples and local spiritual sites that reflect Rajasthan’s rich religious culture. Pilgrims often explore these temples during their Khatu Shyam visit for extended darshan experiences."
    },
    {
        title: "Rajasthan Desert Highway Route",
        description:
            "The journey from Pune to Khatu Shyam Ji passes through long highways, desert regions, and cultural towns of Rajasthan. The route offers a unique travel experience with dhabas, rest stops, and scenic desert landscapes."
    },
    {
        title: "Jaipur (Optional Extension)",
        description:
            "Jaipur, the Pink City, is often included in extended Khatu Shyam tour packages. It is famous for forts, palaces, and cultural heritage, offering a perfect blend of spirituality and tourism."
    },
    {
        title: "Pilgrimage Travel Experience",
        description:
            "The Pune to Khatu Shyam Tour Package is designed for long-distance comfort and devotion. With professional drivers, comfortable vehicles, and flexible planning, it ensures a peaceful and memorable spiritual journey for families and groups."
    }
],



services: [
{
name: "Pune to Khatu Shyam Yatra Package",
description: "Rising Cab Service offers Pune to Khatu Shyam Yatra Package for a comfortable and spiritual long-distance pilgrimage to Khatu Shyam Ji temple. Our package includes clean AC vehicles, professional chauffeurs, doorstep pickup from Pune, and flexible travel planning. Ideal for families and groups, we ensure a safe, peaceful, and well-organized devotional journey with complete travel support throughout the trip."
},
{
name: "Pune to Khatu Shyam Cab Service",
description: "Book Pune to Khatu Shyam Cab Service for a reliable and comfortable outstation journey. We provide well-maintained sedans, SUVs, Innova Crysta, and Tempo Traveller options with experienced drivers and 24x7 booking support for a smooth travel experience."
},
{
name: "Pune to Khatu Shyam Taxi Service",
description: "Our Pune to Khatu Shyam Taxi Service ensures safe, affordable, and stress-free long-distance travel. Enjoy professional chauffeurs, clean vehicles, and flexible pickup and drop services designed for devotional and family trips."
},
{
name: "Pune to Khatu Shyam Cab Booking",
description: "Rising Cab Service provides easy Pune to Khatu Shyam Cab Booking with instant confirmation and multiple vehicle choices. Book online or via call and enjoy a hassle-free pilgrimage journey with complete travel assistance."
},
{
name: "Pune to Khatu Shyam One Way Cab",
description: "Book Pune to Khatu Shyam One Way Cab for budget-friendly drop-only travel. We offer transparent pricing, AC vehicles, and experienced drivers for safe long-distance journeys from Pune to Rajasthan."
},
{
name: "Pune to Khatu Shyam Round Trip Cab",
description: "Our Pune to Khatu Shyam Round Trip Cab service is ideal for return travel with flexible waiting time, comfortable seating, and safe driving for families and groups on pilgrimage tours."
},
{
name: "Pune to Khatu Shyam Taxi Fare",
description: "Get transparent Pune to Khatu Shyam Taxi Fare with affordable pricing based on vehicle type, route, and travel duration. We ensure no hidden charges and best value for long-distance devotional travel."
},
{
name: "Pune to Khatu Shyam Cab Charges",
description: "Rising Cab Service offers clear Pune to Khatu Shyam Cab Charges with budget-friendly options for sedans, SUVs, and premium vehicles, ensuring economical pilgrimage travel."
},
{
name: "Pune to Khatu Shyam Car Rental",
description: "Book Pune to Khatu Shyam Car Rental for a private and comfortable journey with flexible travel stops, AC comfort, and professional chauffeur-driven service."
},
{
name: "Pune to Khatu Shyam Outstation Cab",
description: "Our Pune to Khatu Shyam Outstation Cab service ensures safe and reliable long-distance travel with experienced drivers and well-maintained vehicles for a smooth road trip experience."
},
{
name: "Pune to Khatu Shyam Innova Crysta Cab",
description: "Rising Cab Service provides Pune to Khatu Shyam Innova Crysta Cab for premium comfort, spacious seating, and smooth highway travel, ideal for families and group pilgrimages."
},
{
name: "Pune to Khatu Shyam 7 Seater Cab",
description: "Book Pune to Khatu Shyam 7 Seater Cab for small family trips with comfortable seating, AC interiors, and safe long-distance travel experience."
},
{
name: "Pune to Khatu Shyam Family Cab Service",
description: "Our Pune to Khatu Shyam Family Cab Service is designed for safe and comfortable group travel with flexible stops, clean vehicles, and experienced drivers."
},
{
name: "Pune to Khatu Shyam Darshan Cab",
description: "Rising Cab Service offers Pune to Khatu Shyam Darshan Cab for devotees visiting Khatu Shyam Ji temple, ensuring a peaceful and well-planned spiritual journey."
},
{
name: "Pune to Khatu Shyam Temple Cab Booking",
description: "Book Pune to Khatu Shyam Temple Cab Booking for direct and comfortable travel to the sacred temple with reliable drivers and hassle-free service."
},
{
name: "Pune to Khatu Shyam Taxi Price Per Km",
description: "Get best Pune to Khatu Shyam Taxi Price Per Km with transparent and affordable rates depending on vehicle type and travel distance, ensuring budget-friendly pilgrimage travel."
},
{
name: "Cheap Cab Pune to Khatu Shyam",
description: "Rising Cab Service offers Cheap Cab Pune to Khatu Shyam without compromising safety and comfort. Enjoy affordable long-distance travel with professional service."
},
{
name: "Best Cab Service Pune to Khatu Shyam",
description: "Our Best Cab Service Pune to Khatu Shyam ensures top-quality vehicles, experienced drivers, and reliable support for a smooth and comfortable pilgrimage journey."
},
{
name: "Pune to Khatu Shyam AC Cab Service",
description: "Book Pune to Khatu Shyam AC Cab Service for a comfortable air-conditioned journey with clean interiors and professional chauffeurs for long-distance travel."
},
{
name: "Pune to Khatu Shyam Luxury Cab",
description: "Rising Cab Service provides Pune to Khatu Shyam Luxury Cab with premium vehicles, spacious seating, and elite comfort for a smooth and elegant pilgrimage experience."
}
],

tableData: [
["Pune to Khatu Shyam Yatra Package","Pune to Khatu Shyam Cab Service"],
["Pune to Khatu Shyam Taxi Service","Pune to Khatu Shyam Cab Booking"],
["Pune to Khatu Shyam One Way Cab","Pune to Khatu Shyam Round Trip Cab"],
["Pune to Khatu Shyam Taxi Fare","Pune to Khatu Shyam Cab Charges"],
["Pune to Khatu Shyam Car Rental","Pune to Khatu Shyam Outstation Cab"],
["Pune to Khatu Shyam Innova Crysta Cab","Pune to Khatu Shyam Family Cab Service"],
["Pune to Khatu Shyam Darshan Cab","Pune to Khatu Shyam Temple Cab Booking"],
["Cheap Cab Pune to Khatu Shyam","Best Cab Service Pune to Khatu Shyam"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Khatu Shyam Tour Package",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Khatu Shyam tour packages for devotees, families, senior citizens, pilgrimage groups, and spiritual travelers seeking a memorable religious journey."
    },
    {
        WhyChooseheading: "Convenient Khatu Shyam Ji Darshan Travel",
        WhyChoosedescription: "Travel comfortably to the famous Khatu Shyam Temple in Rajasthan and experience a peaceful spiritual journey with professionally planned transportation."
    },
    {
        WhyChooseheading: "Customized Religious Tour Packages",
        WhyChoosedescription: "Choose from one-way travel, round-trip packages, multi-day pilgrimage tours, family packages, and personalized itineraries according to your requirements."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Travel",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Urbania, and Mini Buses for a comfortable pilgrimage experience."
    },
    {
        WhyChooseheading: "Cover Major Religious Destinations",
        WhyChoosedescription: "Travelers can combine Khatu Shyam Ji Darshan with Salasar Balaji, Rani Sati Temple, Jaipur sightseeing, Ajmer Sharif, Pushkar, and other nearby attractions."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and surrounding locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our professional drivers ensure safe highway travel, smooth long-distance journeys, and comfortable transportation throughout the tour."
    },
    {
        WhyChooseheading: "Ideal for Family and Group Pilgrimages",
        WhyChoosedescription: "Our Khatu Shyam tour packages are suitable for family pilgrimages, bhajan mandals, religious groups, senior citizens, and spiritual gatherings."
    }
]
};

const faqData = [
    {
        question: "Where is Khatu Shyam Ji Temple located?",
        answer: "Khatu Shyam Ji Temple is located in Khatu village near Sikar district in Rajasthan and is one of India's most famous pilgrimage destinations."
    },
    {
        question: "Can I book a complete Pune to Khatu Shyam tour package?",
        answer: "Yes, complete round-trip and customized pilgrimage packages are available from Pune."
    },
    {
        question: "Which vehicle is suitable for a family Khatu Shyam tour?",
        answer: "Ertiga and Innova Crysta are popular choices for families, while Tempo Travellers and Urbania are preferred for larger groups."
    },
    {
        question: "Can Salasar Balaji be included in the package?",
        answer: "Yes, many devotees combine Khatu Shyam Ji Darshan with Salasar Balaji Temple and other religious destinations."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers, Urbania, and Mini Buses can be arranged for group travel and religious tours."
    },
    {
        question: "Can Jaipur sightseeing be included in the itinerary?",
        answer: "Yes, customized packages can include Jaipur attractions, Ajmer, Pushkar, Salasar, and nearby tourist destinations."
    },
    {
        question: "Is the package suitable for senior citizens?",
        answer: "Yes, private vehicle travel provides flexibility, comfort, and convenience for elderly devotees."
    },
    {
        question: "Can hotel accommodations be included in the tour package?",
        answer: "Yes, customized packages can include hotel stays, sightseeing arrangements, and personalized travel plans."
    },
    {
        question: "Is advance booking recommended for Khatu Shyam tours?",
        answer: "Yes, advance reservations are highly recommended during Ekadashi, Falgun Mela, holidays, and peak pilgrimage seasons."
    },
    {
        question: "How can I book a Pune to Khatu Shyam Tour Package?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vinod Agarwal",
        feedback:
            "Our Khatu Shyam Ji pilgrimage was organized perfectly. The vehicle was comfortable, the itinerary was well planned, and the entire journey was peaceful and memorable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rekha Sharma",
        feedback:
            "We traveled with our family to Khatu Shyam and Salasar Balaji. The travel arrangements were excellent, and the driver ensured a safe and comfortable journey throughout the tour.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Khatu Shyam Tour Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-khatu-shyam-cab.jpg",
"description": "Book Pune to Khatu Shyam Tour Package with Rising Cab Service for a comfortable pilgrimage journey. Ideal for family spiritual travel with AC cars, SUVs, and Innova options with professional drivers for safe long-distance trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Custom Package",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-khatu-shyam-tour-package"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Khatu Shyam Tour Package | Pilgrimage Cab Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Khatu Shyam Tour Package for a safe and comfortable pilgrimage journey. Get AC cars, SUVs, and Innova with experienced drivers for long-distance spiritual travel."
/>

<meta
 name="keywords"
 content="pune to khatu shyam yatra package, pune to khatu shyam cab service, pune to khatu shyam taxi service, pune to khatu shyam cab booking, pune to khatu shyam one way cab, pune to khatu shyam round trip cab, khatu shyam tour from pune cab, pilgrimage cab pune khatu shyam"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokhatushyamtour;